import {
    createConsumerField,
    createConsumerFieldValidation,
} from 'constants/FormField/createConsumerField'
import useFromFieldWithAccount from 'logic/useFromFieldWithAccount'

const useConsumers = () => {
    const {
        fieldsCreate,
        fieldsEdit,
        isLoading: isLoadingAccount,
        validationSchema,
    } = useFromFieldWithAccount({
        fieldsCreate: createConsumerField,
        fieldsEdit: createConsumerField,
        validationSchema: createConsumerFieldValidation,
    })

    return {
        fieldsCreate,
        fieldsEdit,
        isLoading: isLoadingAccount,
        validationSchema,
    }
}

export default useConsumers
